/**
 * Builds the `submissionsReturn` mutation input.
 *
 * ALEF-93947: when the host passes a `finishExperienceContext`, it is sent as
 * `finishContext` so assignment-aggregator finishes the LPS assignment
 * experience server-side (with retries) instead of the browser doing it.
 */
export const buildSubmissionsReturnInput = (
  submissionIds,
  finishExperienceContext,
) =>
  finishExperienceContext
    ? { submissionIds, finishContext: finishExperienceContext }
    : { submissionIds };
